var ExternalLinksIdentifier = new Object();

ExternalLinksIdentifier.version = "1.0.0";

ExternalLinksIdentifier.className = "link__ext";

ExternalLinksIdentifier.ignoreHosts = ["wordpress.org", "learn.wordpress.org"];

ExternalLinksIdentifier.init = function () {
  this.logs();

  var _this = this;
  var links = _this.getLinks();

  // helpers.console.log('links:', links);

  _this.tagLinks();
};

ExternalLinksIdentifier.logs = function () {
  // helpers.console.activate();
  // helpers.console.deactivate();
  // helpers.console._prefix = 'ExternalLinksIdentifier:';
  // helpers.console.prefix('ExternalLinksIdentifier:');
};

ExternalLinksIdentifier.tagLinks = function () {
  var _this = this;
  var links = _this.getLinks();

  // helpers.console.log('tagLinks:', links);
  // helpers.console.log('tagLinks:', links);

  for (var i = 0, length = links.length; i < length; i++) {
    if (!links[i].classList.contains(_this.className)) {
      links[i].classList.add(_this.className);
    }
    // helpers.console.log('links[i]', links[i]);
  }
};

ExternalLinksIdentifier.getLinks = function () {
  var _this = this;
  var $links = [];

  document.querySelectorAll("a[href]").forEach((link) => {
    var href = link.getAttribute("href");
    if (!href || href.startsWith("#") || href.startsWith("javascript:")) return;

    try {
      var url = new URL(link.href);
      if (url.hostname && url.hostname !== location.hostname && !_this.shouldIgnore(url.hostname)) {
        $links.push(link);
      }
    } catch (e) {
      // Skip invalid URLs like javascript:void(0)
    }
  });

  return $links;
};

ExternalLinksIdentifier.shouldIgnore = function (hostname) {
  var _this = this;
  var shouldIgnore = true;

  if (!_this.ignoreHosts.includes(hostname)) {
    shouldIgnore = false;
  }

  return shouldIgnore;
};

export default ExternalLinksIdentifier;
